export const MAX_ROOT_LOCATIONS_PER_PAGE = 20;
export const MAX_CHILD_LOCATIONS_PER_PAGE = 10;

export const MAX_ROOT_LOCATIONS_PER_PAGE_SELECTOR = 200;
export const MAX_CHILD_LOCATIONS_PER_PAGE_SELECTOR = 50;
